<template>
  <div class="general">
    <div class="row">
      <div class="col-md-6">
        <label for="">Program Name</label>
        <input v-model="programName" type="text" class="form-control admin-form-control input-md" placeholder="Name of Program">
      </div>
      <div class="col-md-6">
        <label for="">Program URL</label>
        <input v-model="programSlug" type="url" class="form-control admin-form-control input-md" placeholder="Url Endpoint" disabled>
      </div>
    </div>
    <br>
    <div class="row company-container">
      <div class="col-sm-3">
        <label for="">Company Name</label>
        <select
          name=""
          id=""
          v-model="programCompany"
          class="form-control admin-form-control input-md">
          <option value="" disabled selected>Name of Company</option>
          <option
            v-for="(company, index) in companies" :key="index"
            :value="company._id">
            {{ company.name.toUpperCase() }}
          </option>
        </select>
      </div>
      <div class="col-sm-2">
        <button
          type="button"
          class="admin-btn-primary btn btn-md btn-default form-control admin-form-control input-md"
          @click="showCompanyModal = true">
          Add Company
        </button>
      </div>
      <div class="col-md-2">
        <div class="checkbox">
          <label for="">
            <input type="checkbox" name="" id="" v-model="programRequiresApproval">
            Users require approval
          </label>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <br>
    <div class="row">
      <div class="col-sm-4">
        <label for="">Start Date</label>
        <datepicker
          v-model="programStartDate"
          input-class="form-control admin-form-control input-md"
          placeholder="Start Date"
        >
        </datepicker>
      </div>
      <div class="col-sm-4">
        <label for="">End Date</label>
        <datepicker
          v-model="programEndDate"
          input-class="form-control admin-form-control input-md"
          placeholder="End Date"
        >
        </datepicker>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-sm-12">
        <label for="">Rules</label>
        <editor
          name="appendedOutput"
          :api-key="editorKey"
          :init="tinyOptions"
          v-model="programRules"
        ></editor>
        <!-- <textarea v-model="programRules" class="form-control input-md" rows="4" placeholder="Add Rules"></textarea> -->
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-sm-12">
        <label for="">Terms &amp; Conditions</label>
        <editor
          name="appendedOutput"
          :api-key="editorKey"
          :init="tinyOptions"
          v-model="programTerms"
        ></editor>
        <!-- <textarea v-model="programTerms" class="form-control input-md" rows="4" placeholder="Add Terms &amp; Conditions"></textarea> -->
      </div>
    </div>

    <add-company-modal :showCompanyModal="showCompanyModal" v-on:close="showCompanyModal = false"></add-company-modal>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import Datepicker from 'vuejs-datepicker'
import AddCompanyModal from '../AddCompanyModal'
import Editor from '@tinymce/tinymce-vue'

export default {
  name: 'GeneralContent',
  mounted () {
    this.getCompanies()
      .catch(err => console.log(err))
  },
  components: {
    Datepicker,
    AddCompanyModal,
    editor: Editor
  },
  data () {
    return {
      showCompanyModal: false,
      editorKey: '7bb76f8qmjwrxz0hn4kh6gyt3bs2fyk3pv7xavth6kcn3460',
      tinyOptions: {
        body_class: 'form-control admin-form-control input-lg',
        height: 200,
        menubar: false,
        toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright justify | numlist bullist outdent indent | forecolor | removeformat',
        plugins: ['lists']
      }
    }
  },
  computed: {
    ...mapState('loyaltyProgram', [
      'program'
    ]),
    ...mapState('company', [ 'companies' ]),
    programName: {
      get () {
        return this.program.name
      },
      set (value) {
        this.updateProgram({ prop: 'name', value })
      }
    },
    programCompany: {
      get () {
        return this.program.company ? this.program.company._id : ''
      },
      set (value) {
        this.updateProgram({ prop: 'company', value })
      }
    },
    programSlug: {
      get () {
        return this.program.slug
      },
      set (value) {
        this.updateProgram({ prop: 'slug', value })
      }
    },
    programStartDate: {
      get () {
        return this.program.startDate
      },
      set (value) {
        this.updateProgram({ prop: 'startDate', value })
      }
    },
    programEndDate: {
      get () {
        return this.program.endDate
      },
      set (value) {
        this.updateProgram({ prop: 'endDate', value })
      }
    },
    programRequiresApproval: {
      get () {
        return this.program.usersRequireApproval
      },
      set (value) {
        this.updateProgram({ prop: 'usersRequireApproval', value })
      }
    },
    programRules: {
      get () {
        return this.program.rules
      },
      set (value) {
        this.updateProgram({ prop: 'rules', value })
      }
    },
    programTerms: {
      get () {
        return this.program.terms
      },
      set (value) {
        this.updateProgram({ prop: 'terms', value })
      }
    },
    programCategories: {
      get () {
        return this.program.categories
      }
      // set (value) {
      //   console.log(value)
      //   this.updateProgram({prop: 'categories', value})
      // }
    }
  },
  methods: {
    ...mapMutations('loyaltyProgram', {
      updateProgram: 'UPDATE_PROGRAM'
    }),
    ...mapActions('company', [ 'getCompanies', 'createCompany' ]),
    ...mapActions('loyaltyProgram', [ 'saveProgram' ]),
    updateCompany (event) {
      this.updateProgram({ prop: 'company', value: event.target.value })
    }
  }

}
</script>

<style scoped>
.general {
  /* background-color: blue;
  color: white; */
}

.company-container {
  display: flex;
  align-items: flex-end;
}
</style>
